import { createApiCall } from 'lib/base';

const CREATE_SUBSCRIPTION_OPTION = 'CREATE_SUBSCRIPTION_OPTION';

const createSubscriptionOptionApi = createApiCall<{ id: string; payload: any }>(
  CREATE_SUBSCRIPTION_OPTION,
  ({ id, payload }) => ({
    endpoint: `api/admin/subscriptions/${id}/options`,
    method: 'POST',
    body: payload,
  })
);

export default createSubscriptionOptionApi;
